// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-box-icon {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: var(--icon-height, 3rem);
  width: var(--icon-width, 3rem);
  color: var(--ion-color-light);
}`, "",{"version":3,"sources":["webpack://./src/app/components/casino-lobby/keywords-casino/cdn-icon/cdn-icon.scss"],"names":[],"mappings":"AAAA;EACI,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,gCAAA;EACA,8BAAA;EACA,6BAAA;AACJ","sourcesContent":[".image-box-icon {\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n    background-position: center;\r\n    height: var(--icon-height, 3rem);\r\n    width: var(--icon-width, 3rem);\r\n    color: var(--ion-color-light);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
